export default __webpack_public_path__ + "static/media/add-fill.0a7a07e3.svg";